import React from 'react';

import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  FAQ,
} from '../../../components';

import './style.scss';

const ParagraphFAQ = ({ entity }) => {
  const items = entity.getIn(['field_faq']);
  const ctaText = entity.getIn(['field_cta_text', 0, 'value']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const title = entity.getIn(['field_title', 0, 'value']);

  return (
    <Container className="Paragraph ParagraphFAQ">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <h3>{title}</h3>
          <div className="ParagraphFAQ__content__items">
            {items && items.size > 0 && (
              items.map((item, index) => {
                const question = item.getIn(['entity', 'title', 0, 'value']);
                const answer = item.getIn(['entity', 'field_answer', 0, 'processed']);
                const uuid = item.getIn(['entity', 'uuid', 0, 'value']);

                return (
                  <FAQ key={uuid} question={question} answer={answer} />
                );
              })
            )}
          </div>
          <div className="ParagraphFAQ__cta__wrapper">
            {ctaText && (
              <div className="ParagraphFAQ__cta">{ctaText}</div>
            )}
            {linkUri && linkTitle && (
              <div className="ParagraphFAQ__Button">
                <Button className="Button Button--primary" href={linkUri}>{linkTitle}<i className="icon-after icon-arrow-right icon-variant-2" /></Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphFAQ;
